import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import types from './types';

const actions = {
  async getProducts({ commit }, payload) {
    try {
      commit(types.GET_PRODUCT_START);
      if (payload === 'digitize') {
        const [{ data: { data: digitizeData } }, { data: { data: cloudData } }] = await Promise.all(
          [
            apiCall({
              type: 'GET',
              url: `${URLS.product}`,
              params: { type: payload },
              isToken: true,
            }),
            apiCall({
              type: 'GET',
              url: `${URLS.product}`,
              params: { type: 'forever_cloud' },
              isToken: true,
            }),
          ],
        );
        commit(types.GET_PRODUCTS_SUCCESS, [...digitizeData, ...cloudData]);
      } else if (payload === 'enhance') {
        const { data: { data } } = await apiCall({
          type: 'GET',
          url: `${URLS.product}`,
          params: { type: payload },
          isToken: true,
        });
        const newData = data.filter(({ productCollectionId }) => !productCollectionId);
        commit(types.GET_PRODUCTS_SUCCESS, newData);
      } else {
        const { data: { data } } = await apiCall({
          type: 'GET',
          url: `${URLS.product}`,
          params: {
            type: payload === 'deliveries'
              ? null : payload,
          },
          isToken: true,
        });
        const newData = payload === 'deliveries'
          ? data.filter(({ name }) => name === 'local_pickup' || name === 'fs_ship_kit')
          : data;
        commit(types.GET_PRODUCTS_SUCCESS, newData);
      }
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_PRODUCTS_FAILURE, message);
    }
  },
  async getProductListForPromo({ commit }) {
    try {
      const [
        { data: { data: digitizeProducts } },
        { data: { data: enhanceProductsWithoutFilter } },
        { data: { data: shippingProducts } },
        { data: { data: createProducts } },
      ] = await Promise.all(
        [
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'digitize' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'enhance' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'shipping' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.createTemplateFrames,
            isToken: true,
          }),
        ],
      );
      const enhanceProducts = enhanceProductsWithoutFilter.filter(
        ({ productCollectionId }) => !productCollectionId,
      );
      commit(types.GET_PRODUCTS_SUCCESS, [
        ...digitizeProducts,
        ...enhanceProducts,
        ...shippingProducts,
        ...createProducts,
      ]);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateProduct({ dispatch }, payload) {
    try {
      const { id, type = '', ...rest } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.product}/${id}`,
        body: rest,
        isToken: true,
      });
      notificationWithIcon('success', 'Product updated');
      if (type) {
        dispatch('getProducts', type);
      }
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteProduct({ dispatch }, payload) {
    try {
      const { id, type } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.product}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Product deleted');
      dispatch('getProducts', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async addGiftCard({ dispatch }, values) {
    try {
      await apiCall({
        type: 'POST',
        url: `${URLS.product}/gift_card`,
        body: values,
        isToken: true,
      });
      notificationWithIcon('success', 'Gift card added');
      dispatch('getProducts', 'gift_card');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async addProductOption({ dispatch }, payload) {
    try {
      const {
        id,
        productType,
        type,
        ...rest
      } = payload;
      await apiCall({
        type: 'POST',
        url: `${URLS.product}/${id}/option/${productType}`,
        body: rest,
        isToken: true,
      });
      notificationWithIcon('success', 'Product option created');
      dispatch('getProducts', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateOptionPositions({ dispatch }, payload) {
    try {
      const {
        type,
        changePosition,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: URLS.positions,
        body: {
          changePosition,
        },
        isToken: true,
      });
      notificationWithIcon('success', 'Positions updated');
      dispatch('getProducts', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async getCardImages({ commit }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.productGiftImg,
        isToken: true,
      });
      commit('GET_CARD_IMAGES_SUCCESS', data);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async createCardImage({ dispatch }, payload) {
    const { name, index, file } = payload;
    const formData = new FormData();
    formData.append('file', file.file);
    formData.append('name', name);
    formData.append('index', index);
    try {
      await apiCall({
        type: 'POST',
        headers: { 'content-type': 'multipart/form-data' },
        url: URLS.productGiftImg,
        body: formData,
        isToken: true,
      });
      notificationWithIcon('success', 'Gift image added');
      dispatch('getCardImages');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async changeGiftImage({ dispatch }, payload) {
    const { id, ...rest } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.productGiftImg}/${id}`,
        body: rest,
        isToken: true,
      });
      notificationWithIcon('success', 'Gift image updated');
      dispatch('getCardImages');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteGiftImage({ dispatch }, id) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.productGiftImg}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Gift image deleted');
      dispatch('getCardImages');
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async getProductCollections({ commit }, type) {
    try {
      commit(types.GET_PRODUCT_COLLECTIONS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: URLS.productCollections,
        params: {
          pageKey: type,
        },
        isToken: true,
      });
      commit(types.GET_PRODUCT_COLLECTIONS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_PRODUCT_COLLECTIONS_FAIL, message);
    }
  },
  async getOneProductCollections({ commit }, id) {
    try {
      commit(types.GET_ONE_PRODUCT_COLLECTIONS_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.productCollections}/${id}`,
        isToken: true,
      });
      commit(types.GET_ONE_PRODUCT_COLLECTIONS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_ONE_PRODUCT_COLLECTIONS_FAIL, message);
    }
  },
  async getAllProductCollections({ commit }, payload) {
    try {
      commit(types.GET_ALL_PRODUCT_COLLECTIONS_START);
      const allCollections = await Promise.all(payload.map(async (id) => {
        const { data: { data } } = await apiCall({
          type: 'GET',
          url: `${URLS.productCollections}/${id}`,
          isToken: true,
        });
        return data;
      }));
      commit(types.GET_ALL_PRODUCT_COLLECTIONS_SUCCESS, allCollections);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_ALL_PRODUCT_COLLECTIONS_FAIL, message);
    }
  },
  clearOneProductCollections({ commit }) {
    commit(types.CLEAR_CURRENT_PRODUCT_COLLECTIONS);
  },
  async getAllProducts({ commit }) {
    try {
      commit(types.GET_ALL_PRODUCTS_START);
      const [
        { data: { data: digitizeProducts } },
        { data: { data: enhanceProducts } },
        { data: { data: shippingProducts } },
        { data: { data: createProducts } },
      ] = await Promise.all(
        [
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'digitize' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'enhance' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.product,
            params: { type: 'shipping' },
            isToken: true,
          }),
          apiCall({
            type: 'GET',
            url: URLS.createTemplateFrames,
            isToken: true,
          }),
        ],
      );
      const data = {
        digitizeProducts,
        enhanceProducts,
        shippingProducts,
        createProducts,
      };
      commit(types.GET_ALL_PRODUCTS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_ALL_PRODUCTS_FAILURE, message);
    }
  },
  async getCompanyProductByProductId(_, productId) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.companyProducts}/by-product/${productId}`,
        isToken: true,
      });
      return data;
    } catch (err) {
      // If no company product found, return null instead of showing error
      if (err.response && err.response.status === 404) {
        return null;
      }
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
      throw err;
    }
  },
  async createCompanyProduct(_, payload) {
    try {
      const { data: { data } } = await apiCall({
        type: 'POST',
        url: URLS.companyProducts,
        body: payload,
        isToken: true,
      });
      notificationWithIcon('success', 'Company product created successfully');
      return data;
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
      throw err;
    }
  },
  async updateCompanyProduct(_, { id, ...payload }) {
    try {
      const { data: { data } } = await apiCall({
        type: 'PUT',
        url: `${URLS.companyProducts}/${id}`,
        body: payload,
        isToken: true,
      });
      notificationWithIcon('success', 'Company product updated successfully');
      return data;
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
      throw err;
    }
  },
  async getCompanyProductsByCompanyId(_, companyId) {
    try {
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.companyProducts}/by-company/${companyId}`,
        isToken: true,
      });
      return data;
    } catch (err) {
      // If no company products found, return empty array instead of showing error
      if (err.response && err.response.status === 404) {
        return [];
      }
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
      throw err;
    }
  },
};

export default actions;
